export class EntityTotals {
    constructor(
        public STUDENT: number = 0,
        public CONTACT: number = 0,
        public STAFF: number = 0,
        public COURSE: number = 0,
        public ROSTER: number = 0,
        public CALENDAR: number = 0,
        public GROUP: number = 0,
        public SCHOOL_ADMIN: number = 0,
        public ROSTER_STUDENT_ENROLLMENT: number = 0,
        public SCHOOL: number = 0,
        public LINE_ITEM: number = 0,
        public ASSESSMENT_LINE_ITEM: number = 0,
        public RESULT: number = 0,
        public ASSESSMENT_RESULT: number = 0,
        public SCORE_SCALE: number = 0,
        public CATEGORY: number = 0,
        public RESOURCE: number = 0
    ) {
    }
}

export class SchoolEntityTotals extends EntityTotals {
    constructor(
        STUDENT: number = 0,
        CONTACT: number = 0,
        STAFF: number = 0,
        COURSE: number = 0,
        ROSTER: number = 0,
        CALENDAR: number = 0,
        GROUP: number = 0,
        SCHOOL_ADMIN: number = 0,
        ROSTER_STUDENT_ENROLLMENT: number = 0,
        SCHOOL: number = 0,
        public SCHOOL_GUID: string = '',
        public SCHOOL_NAME: string = ''
    ) {
        super(STUDENT, CONTACT, STAFF, COURSE, ROSTER, CALENDAR, GROUP, SCHOOL_ADMIN, ROSTER_STUDENT_ENROLLMENT, SCHOOL);
    }
}

export class SchoolsEntityTotals {
    [schoolId: string]: SchoolEntityTotals;
}
